var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121 125",
    className: "jfWizard-list-item-icon-svg",
    width: 187,
    height: 204,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.417 0h112a4 4 0 014 4v121h-120V4a4 4 0 014-4z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.417 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.001 31.122h79.14a2.858 2.858 0 010 5.716h-79.14a2.858 2.858 0 110-5.716z",
    fill: "#DAE2ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    y: 20.324,
    width: 74.571,
    height: 5.716,
    rx: 2.858
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    width: 99,
    height: 8.257,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.001 41.284h79.14a2.858 2.858 0 010 5.716h-79.14a2.858 2.858 0 110-5.716z",
    fill: "#DAE2ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2F90FF",
    fillRule: "nonzero",
    width: 6.429,
    height: 6.351,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.734 4.765a.33.33 0 01-.238-.103L1.304 3.424a.36.36 0 010-.495.328.328 0 01.477 0l.953.99L4.878 1.69a.328.328 0 01.477 0 .36.36 0 010 .496L2.972 4.662a.33.33 0 01-.238.103",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    y: 40.649,
    width: 6.429,
    height: 6.351,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.417 72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.036 10.929h79.071a2.893 2.893 0 010 5.785H17.036a2.893 2.893 0 110-5.785zM2.893 0h68.786a2.893 2.893 0 110 5.786H2.893a2.893 2.893 0 010-5.786zm14.143 21.214h79.071a2.893 2.893 0 010 5.786H17.036a2.893 2.893 0 110-5.786z",
    fill: "#DAE2ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.286)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2F90FF",
    fillRule: "nonzero",
    width: 6.429,
    height: 6.429,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.734 4.823a.327.327 0 01-.238-.104L1.304 3.465a.367.367 0 010-.5.325.325 0 01.477 0l.953 1.002L4.878 1.71a.325.325 0 01.477 0 .367.367 0 010 .501L2.972 4.72a.328.328 0 01-.238.104",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    y: 20.571,
    width: 6.429,
    height: 6.429,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2F90FF",
    fillRule: "nonzero",
    width: 6.429,
    height: 6.429,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.734 4.823a.327.327 0 01-.238-.104L1.304 3.465a.367.367 0 010-.5.325.325 0 01.477 0l.953 1.002L4.878 1.71a.325.325 0 01.477 0 .367.367 0 010 .501L2.972 4.72a.328.328 0 01-.238.104",
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#2F90FF",
    fillRule: "nonzero",
    x: 77.417,
    y: 109,
    width: 32,
    height: 10,
    rx: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassic);
export default __webpack_public_path__ + "static/media/Classic.293b1811.svg";
export { ForwardRef as ReactComponent };